import { createRouter } from "@tanstack/react-router";
import { CustomErrorComponent } from "./components/custom/router/custom-error";
import { NotFoundRoute } from "./components/custom/router/not-found-route";
import { queryClient } from "./lib/query-client";
import { routeTree } from "./routeTree.gen";

// Constants for timing configurations
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const DEFAULT_STALE_TIME_SECONDS = 3;
const PRELOAD_GC_TIME_HOURS = 1;

// Create a new router instance
export const router = createRouter({
  routeTree,
  basepath: "/",
  defaultNotFoundComponent: NotFoundRoute,
  defaultErrorComponent: CustomErrorComponent,
  defaultPreload: "intent",
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultStaleTime: MILLISECONDS_PER_SECOND * DEFAULT_STALE_TIME_SECONDS,
  defaultPreloadGcTime:
    MILLISECONDS_PER_SECOND *
    SECONDS_PER_MINUTE *
    MINUTES_PER_HOUR *
    PRELOAD_GC_TIME_HOURS,
  context: {
    queryClient,
  },
});

export type Router = typeof router;

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // biome-ignore lint/style/useConsistentTypeDefinitions: This is ok
  interface Register {
    router: Router;
  }
}
